import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-view-subadmin',
  templateUrl: './view-subadmin.component.html',
  styleUrls: ['./view-subadmin.component.css']
})
export class ViewSubadminComponent implements OnInit {

  myPermission: any = [];
  subAdminList: any;
  userId: any;
  permission: any;

  constructor(private mainService: MainService, private activatedroute: ActivatedRoute) {
    this.activatedroute.params.subscribe(res => {
      this.userId = res.id
    })
  }

  ngOnInit() {
    this.getSubAdminList()
  }

  // getSubAdminList api integration 
  getSubAdminList() {

    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.viewSubadmin + `?userId=${this.userId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.subAdminList = res.result;
        this.permission = res['result']['permissions'][0];
        var result = Object.entries(this.permission)
        for (var i = 0; i < result.length; i++) {
          for (var z = 0; z < result[i].length; z++) {
            if (result[i][z] == true) {
              var v = result[i][0];
              var len = v.length;
              var len = v.length;
              if (v == "dashboard") {
                var finalper = v
              }
              else {
                finalper = v.slice(0, len - 10) + ' ' + 'Management'
              }
              this.myPermission.push(finalper);
            }
          }
        }
        this.mainService.hideSpinner();
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
